import getCurrentSelectedTableView from '../utils/getSelectedTableView';
import isMiniFeatureEnabled from 'owa-mini-feature-flags/lib/isMiniFeatureEnabled';
import { type TableQueryType } from '../store/schema/TableQuery';

export const isUnifiedSearchView = () => {
    const currentTableView = getCurrentSelectedTableView();
    return isMiniFeatureEnabled('mini-unified-search') && currentTableView?.tableQuery?.type === 1;
};
